<template>
    <div
        ref="wrapper"
        class="page-container"
        v-spinner="!pageDataLoaded"
    >
    <v-spinner :opacity="0.5">{{ $t('加载中...') }}</v-spinner>
    <template v-if="pageDataLoaded" >
        <Title v-model="currAccountInfo" />
        <!-- 列表 -->
        <div
            v-if="accountListLength"
            class="keyword-reply-content"
        >
            <v-status-bar kind="alarm">
                <span>{{ $t('因微信政策调整，自动回复消息将不再支持多图文。') }}</span>
            </v-status-bar>
            <!-- 有数据时的列表 -->
            <v-button
                @click="goSingle"
                class="keyword-reply-but"
                kind="primary"
                icon="basic_new_line"
                remote
                :label="$t('新建规则')"
            />
            <grid
                ref="grid"
                :params="params"
                url="/mp/rest/keywordReply"
                method="get"
                class="word-list"
            >
                <v-table-column :label="$t('规则名')">
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <div>{{ props.row.ruleName }}</div>
                    </template>
                </v-table-column>
                <v-table-column :label="$t('关键词')">
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <span
                            v-for="(item, index) in props.row.keywordArr"
                            :key="index"
                            class="word-list-tag"
                        >
                            <v-tag
                                :text="item"
                                :maxWidth="70"
                                color="default"
                                size="small"
                            />
                        </span>
                    </template>
                </v-table-column>
                <v-table-column :label="$t('回复')">
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <div v-if="props.row.action == 'reply'">
                            <span>{{ $t('{n}条', { n: props.row.replyArr.length }) }}</span>
                            <span>{{ getImgText(props.row.replyArr) }}</span>
                        </div>
                        <div v-else-if="props.row.action == 'manual'" style="word-break: break-all;">
                            <template v-if="props.row.routeId">
                                {{ $t('高级分配规则-{name}', { name: props.row.routeName }) }}
                            </template>
                            <template v-else>
                                <span v-if="props.row.manualType === 2">
                                    <span>{{ $t('客服') }}&nbsp;</span>
                                    <span class="manual-name">{{ props.row.serviceKfextName }}</span>
                                </span>
                                <span v-else-if="props.row.manualType === 3">
                                    <span>{{ $t('客服分组') }}&nbsp;</span>
                                    <span class="manual-name">{{ props.row.groupName }}</span>
                                </span>
                                &nbsp;<span>{{ $t('进行人工服务') }}</span>
                            </template>
                        </div>
                    </template>
                </v-table-column>
                <v-table-column :label="$t('状态')">
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <v-switch
                            v-model="props.row.status"
                            @click="wordStatus(props.row.status, props.row.id)"
                        />
                    </template>
                </v-table-column>
                <v-table-column
                    align="right"
                >
                    <template
                        slot="cell"
                        slot-scope="props"
                    >
                        <v-button-group class="btn-demo">
                            <v-button
                                @click="handleEdit(props.row.id)"
                                type="link"
                                kind="primary"
                            >
                                {{ $t('编辑') }}
                            </v-button>
                            <v-button
                                @click="deleteData=true;currentItem=props.row"
                                type="link"
                                kind="primary"
                            >
                                {{ $t('删除') }}
                            </v-button>
                        </v-button-group>
                    </template>
                </v-table-column>
            </grid>
            <!-- 删除 -->
            <v-dialog
                v-model="deleteData"
                @confirm="handleDelete"
                :title="$t('删除该规则？')"
                kind="confirm"
                status="warning"
            >
                <span slot="confirm-text">{{ $t('删除') }}</span>
            </v-dialog>
        </div>
        <div v-else>
            <no-weixin-account :currAccountInfo="currAccountInfo" />
        </div>
    </template>
    </div>
</template>

<script>
// 注意，因为这个组件营销和客服是公用的。所以在去框架机的时候，专为客服单独写了一个组件。
import Title from '../components/Title-nohengine.vue';
import Grid from 'src/components/grid';
import NoWeixinAccount from '../components/no-weixin-account.vue';
import { Icon } from 'vhtml-ui';
const req = require.context('../assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);
import mixin from '../../mixinAccount';

export default {
    mixins: [mixin],
    components: { Title, Grid, NoWeixinAccount },
    data() {
        return {
            currentItem: '',
            deleteData: false,
            accountID: 0,
            // recordArr: window.data && window.data.data.records,
            record: {},
            keywordArr: [],
            replyArr: [],
            currAccountInfo: {},
            accountListLength: 0,
            // 页面数据是否加载完成
            pageDataLoaded: false,
        };
    },
    computed: {
        params() {
            return {
                accountID: this.accountID,
            };
        },
    },
    watch: {},
    async created() {
        // 加载基本数据
        await this.initBaseInfo();

        // 页面loaded
        this.pageDataLoaded = true;
    },
    mounted() {},
    methods: {
        // 回复列表
        getImgText(val) {
            let replyTxtCount = 0;
            let replyImgCount = 0;
            let replyImgTxtCount = 0;
            val && val.forEach((i) => {
                if (i.replyType === 1) {
                    // eslint-disable-next-line no-plusplus
                    replyTxtCount++;
                } else if (i.replyType === 2 || i.replyType === 10) {
                    // eslint-disable-next-line no-plusplus
                    replyImgCount++;
                } else if (i.replyType === 3) {
                    // eslint-disable-next-line no-plusplus
                    replyImgTxtCount++;
                }
            });
            return this.$t('({txt}文字，{img}图片，{imgTxt}图文)', {
                txt: replyTxtCount,
                img: replyImgCount,
                imgTxt: replyImgTxtCount,
            });
        },
        // 状态
        wordStatus(status, id) {
            const params = {
                accountID: this.accountID.toString(),
                0: id,
            };
            // 注意，v-switch组件会把这个值从数字改成boolean类型，因此这里修改判断逻辑
            this.$ajax.update(
                status ? '/mp/keywordReply/stop' : '/mp/keywordReply/open', params,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    transformRequest: [
                        data => JSON.stringify(data),
                    ],
                }
            ).then((res) => {
                if (res.r === 0) {
                    this.$message.success(status ? this.$t('已停用') : this.$t('已启用'));
                } else {
                    this.$message.error(res.msg || this.$t('操作失败'));
                }
            })
                .catch((e) => {
                    this.$message.error(e.msg || this.$t('操作失败'));
                });
        },
        // 编辑
        handleEdit(id) {
            window.open(`/mp/keywordReply/single?accountID=${this.accountID}&id=${id}`, '_self');
        },
        // 删除
        handleDelete() {
            this.$ajax.remove(`/mp/rest/keywordReply/${this.currentItem.id}`, {
                accountID: this.accountID.toString(),
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
                transformRequest: [
                    data => JSON.stringify(data),
                ],
            },).then(() => {
                this.$message.success(this.$t('删除成功'));
                // 删除之后直接回到第一页数据
                this.$refs.grid.refreshList();
                setTimeout(() => {
                    // 重新更新数据
                    this.$refs.grid.update();
                }, 50);
            })
                .catch((e) => {
                    this.$message.error(e.msg || this.$t('删除失败'));
                });
        },
        goSingle() {
            window.open(`/mp/keywordReply/single?accountID=${this.accountID}`, '_self');
        },

    },
};
</script>
<style lang="less" scoped>
@import './app.less';
.page-container {
    padding: 16px 32px 50px 32px;
    flex: 1;
    overflow: hidden;
    .keyword-reply-content {
        .keyword-reply-but {
            margin: var(--spacing-loose) 0;
        }
        .no-data {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 150px;
            .no-data-image {
                width: 69px;
                height: 100px;
            }
            .no-data-msg {
                margin-bottom: var(--spacing-loose);
                color: var(--color-text-caption);
            }
        }
    }
    .word-list {
        .word-list-tag {
            margin-right: var(--spacing-base);
        }
    }
}
</style>
